import React from "react";

// Spin-wheel endpoints aren't on the new backend yet. The full wheel UI lives
// in git history — restore it when `/rakeback/daily-spin-wheel/*` lands.
const SpinWheel = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] text-white font-sans p-6 text-center">
            <div className="w-24 h-24 bg-yellow-500/10 rounded-full flex items-center justify-center mb-6 border border-yellow-500/20">
                <span className="text-5xl">🎁</span>
            </div>
            <h2 className="text-3xl font-black mb-2 tracking-tight uppercase">Coming Soon</h2>
            <p className="text-white/60 max-w-xs leading-relaxed">
                Daily spin wheel rewards are temporarily unavailable while the new backend integration is finalized.
            </p>
        </div>
    );
};

export default SpinWheel;
